var map = {
	"./es-AR/localidades": [
		1324,
		1324
	],
	"./es-AR/localidades.json": [
		1324,
		1324
	],
	"./es-AR/provincias": [
		8727,
		6962
	],
	"./es-AR/provincias.json": [
		8727,
		6962
	],
	"./es-PE/departamentos": [
		9980,
		9980
	],
	"./es-PE/departamentos.json": [
		9980,
		9980
	],
	"./es-PE/distritos": [
		6195,
		6195
	],
	"./es-PE/distritos.json": [
		6195,
		6195
	],
	"./es-PE/provincias": [
		8044,
		8044
	],
	"./es-PE/provincias.json": [
		8044,
		8044
	],
	"./es-PE/ubigeos": [
		7728,
		7728
	],
	"./es-PE/ubigeos.json": [
		7728,
		7728
	],
	"./es-UY/localidades": [
		9720,
		9720
	],
	"./es-UY/localidades.json": [
		9720,
		9720
	],
	"./es-UY/provincias": [
		1185,
		1185
	],
	"./es-UY/provincias.json": [
		1185,
		1185
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3980;
module.exports = webpackAsyncContext;